import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { LOCATION_PATH, addLocation } from '../../api/locationApi'
import { addLocationAction } from '../../redux/feature/locationSlice'

const LocationSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newLocation, setNewLocation] = useState({
        code: "",
        name: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${LOCATION_PATH}`, true)

    const onClickSubmit = () => {
        addLocation(newLocation)
            .then(res => {
                dispatch(addLocationAction(res.data))
                closeTab()
                toast.success('Lokasyon kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Lokasyon</label>
                <Input
                    label='Lokasyon Kodu'
                    name='code'
                    placeholder='Lokasyon kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewLocation, setErrors)}
                />
                <Input
                    label='Lokasyon Adı'
                    name='name'
                    placeholder='Lokasyon adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewLocation, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewLocation, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default LocationSubmitPage